export const personalInfo = {
  name: 'Alphonse Ngandjui',
  title: 'DevOps Engineer | AI & LLMOps',
  email: 'ngandjuialphonse11@gmail.com',
  phone: '+1 (920) 316-2220',
  location: 'Germantown, Wisconsin',
  description:
    'DevOps engineer specializing in cloud infrastructure, platform automation, CI/CD, and AI/LLM operations. I build secure, observable, and scalable delivery workflows for applications and AI-enabled services.',
  social: {
    linkedin: 'https://www.linkedin.com/in/alphonse-ngandjui-a34741287',
    github: 'https://github.com/ngandjuialphonse',
    youtube: 'https://www.youtube.com/@ElTechEngineer'
  }
};

export const experience = [
  {
    id: 'exp1',
    title: 'DevOps Engineer',
    company: 'Hansen Technologies',
    companyUrl: 'https://www.hansencx.com/',
    location: '74 W Broad St, Ste 530, Bethlehem, PA 18018',
    period: 'April 17, 2023 – Present',
    description:
      'Build and operate secure, scalable cloud platforms, delivery pipelines, and AI/LLM-enabled services with a focus on reliability, automation, observability, and cost efficiency.',
    achievements: [
      'Migrated CI/CD pipelines to Jenkins, reducing deployment time by 30%.',
      'Automated AWS infrastructure provisioning with Terraform, saving 15 hours of manual work each week.',
      'Managed Kubernetes workloads and platform operations while maintaining 99.9% availability.',
      'Expanded observability with Prometheus and Grafana, reducing incident response time by 60%.',
      'Established LLMOps practices for prompt, configuration, model, and deployment versioning across development and production environments.',
      'Introduced automated evaluation and release checks for AI-enabled services, covering quality, regression, latency, reliability, and cost.',
      'Strengthened cloud security with IAM policies and SSL/TLS controls, reducing security incidents by 70%.',
      'Optimized AWS resources and operating practices, reducing cloud costs by 20%.'
    ],
    technologies: [
      'AWS',
      'Azure',
      'Kubernetes',
      'Docker',
      'Terraform',
      'Ansible',
      'Jenkins',
      'GitHub Actions',
      'Python',
      'Prometheus',
      'Grafana',
      'AI/LLMOps'
    ]
  },
  {
    id: 'exp2',
    title: 'DevOps Engineer Intern',
    company: 'Data Service Group Inc. (DSG)',
    companyUrl: 'https://www.dataservicegroup.com/',
    location: 'Remote · 60 Fir Ave, Bear, DE 19701',
    period: 'March 2020 – April 16, 2023',
    description:
      'Supported cloud migration, release automation, configuration management, and production reliability for custom software and infrastructure services.',
    achievements: [
      'Supported application migrations to cloud environments, contributing to a 30% reduction in infrastructure costs.',
      'Built and maintained CI/CD pipelines with Jenkins and GitLab CI, improving release productivity by 35%.',
      'Automated configuration and deployment workflows with Ansible, reducing manual errors by 60%.',
      'Supported containerized environments and operational practices that maintained 99.99% availability.',
      'Improved monitoring and incident visibility with Prometheus and Grafana, increasing system reliability by 50%.',
      'Automated recurring operational tasks with Bash and Python, saving more than 200 hours of manual effort per month.'
    ],
    technologies: [
      'AWS',
      'Azure',
      'Docker',
      'Kubernetes',
      'Terraform',
      'Ansible',
      'Jenkins',
      'GitLab CI',
      'Python',
      'Bash',
      'Prometheus',
      'Grafana'
    ]
  }
];

export const projects = [
  {
    id: 'optimum-space-services',
    name: 'Optimum Space Services',
    url: 'https://optimumspaceservices.com/',
    category: 'Cleaning Services',
    status: 'Live',
    description:
      'Designed and deployed a service-focused website for a Wisconsin cleaning company, organizing commercial and residential offerings, service coverage, scheduling information, and quote requests.'
  },
  {
    id: 'evercare-personal-services',
    name: 'EverCare Personal Services',
    url: 'https://evercarepersonalservices.com/',
    category: 'Home Care Services',
    status: 'Live',
    description:
      'Built and deployed an accessible website for a non-medical in-home care provider, with service information, pricing, FAQs, coverage details, and a care-request journey.'
  },
  {
    id: 'trouvit-solutions',
    name: 'TrouviT Solutions',
    url: 'https://trouvitsolutions.com/',
    category: 'IT Consulting',
    status: 'Live',
    description:
      'Designed and deployed a full-service IT consulting website presenting managed IT, cybersecurity, cloud, infrastructure, software, data and AI, and technology strategy services.'
  },
  {
    id: 'tranquil-heart-living',
    name: 'Tranquil Heart Living',
    url: 'https://tranquilheartliving.com/',
    category: 'Adult Family Home',
    status: 'Live',
    description:
      'Designed and deployed a planned Adult Family Home website presenting a person-centered care approach, services, admissions information, and tour and contact pathways in Germantown, Wisconsin.'
  },
  {
    id: 'bestill-capital',
    name: 'BeStill Capital',
    url: 'https://bestillcapital.com/',
    category: 'Financial Education Platform',
    status: 'Live',
    description:
      'Built and deployed an education-first trading platform that combines stock and options lessons, decision journaling, analytics, watchlists, and AI-assisted reflection.'
  },
  {
    id: 'sulai-forward',
    name: 'SULAI FORWARD',
    url: 'https://sulaiforward.com/',
    category: 'Personal Growth & Leadership',
    status: 'Live',
    description:
      'Designed and deployed a personal growth and leadership website presenting coaching, speaking, stories, a forthcoming book, and support pathways for the SULAI FORWARD brand.'
  },
  {
    id: 'el-tech-engineer',
    name: 'El Tech Engineer',
    url: 'https://eltechengineer.org/',
    category: 'Technology Education',
    status: 'Live',
    description:
      'Designed and deployed a DevOps and AI/LLMOps education website with bilingual learning paths, sample lessons, a practice lab, coaching, and resources.'
  }
];

export const skills = [
  {
    category: 'Cloud & Infrastructure',
    items: ['AWS & Azure', 'Terraform & Ansible', 'Kubernetes'],
    proficiency: [90, 85, 88]
  },
  {
    category: 'CI/CD & Automation',
    items: ['Jenkins', 'GitLab CI', 'GitHub Actions'],
    proficiency: [92, 85, 88]
  },
  {
    category: 'AI & LLMOps',
    items: ['LLM Delivery Workflows', 'Evaluation & Observability', 'Prompt & Model Versioning'],
    proficiency: [85, 84, 82]
  },
  {
    category: 'Containers & Systems',
    items: ['Linux', 'Docker', 'Kubernetes'],
    proficiency: [90, 88, 88]
  },
  {
    category: 'Scripting & Programming',
    items: ['Python', 'Bash', 'JavaScript'],
    proficiency: [90, 90, 50]
  },
  {
    category: 'Monitoring & Data',
    items: ['Prometheus & Grafana', 'Splunk', 'Liquibase & SQL'],
    proficiency: [90, 88, 85]
  }
];

export const certifications = [
  {
    id: 'cert1',
    name: 'AWS Certified Solutions Architect',
    issuer: 'Amazon Web Services',
    date: '2023',
    verifyUrl: 'https://www.credly.com/badges/ea82a0f7-9d7a-457c-9250-af8b2a79620a'
  },
  {
    id: 'cert2',
    name: 'Certified Kubernetes Administrator (CKA)',
    issuer: 'Cloud Native Computing Foundation',
    date: '2023',
    verifyUrl: 'https://www.credly.com/badges/714595da-3a15-4352-a384-afa5b4913b75'
  },
  {
    id: 'cert3',
    name: 'HashiCorp Certified: Terraform Associate',
    issuer: 'HashiCorp',
    date: '2023',
    verifyUrl: 'https://www.credly.com/badges/7a7a00ef-be4b-4cd9-a663-d3edd33ed033'
  }
];

export const education = [
  {
    id: 'edu1',
    degree: "Master's Degree in Science",
    school: 'University of Douala',
    location: 'Cameroon',
    period: '2013 – 2015'
  },
  {
    id: 'edu2',
    degree: "Bachelor's Degree in Science",
    school: 'University of Douala',
    location: 'Cameroon',
    period: '2008 – 2012'
  }
];
